"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _toInteger = _interopRequireDefault(require("lodash/toInteger"));

var _ariaRole = require("../utils/aria-role");

var _FeListItem = _interopRequireDefault(require("./FeListItem"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var FeListItemGroup =
/*#__PURE__*/
function (_Component) {
  _inherits(FeListItemGroup, _Component);

  function FeListItemGroup() {
    _classCallCheck(this, FeListItemGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(FeListItemGroup).apply(this, arguments));
  }

  _createClass(FeListItemGroup, [{
    key: "isActiveItem",
    value: function isActiveItem(item) {
      if (this.props.activeId && (item.id || this.props.idAttribute)) {
        return this.props.activeId === (item.id || item[this.props.idAttribute]);
      } else {
        return false;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      /** Minimum condition required to render*/


      if (this.props.list && this.props.list.length === 0) {
        return null;
      }
      /** Rendering of component */


      var className = (0, _classnames.default)('fe-list', {
        'fe-sub-list': this.props.isSublist,
        'fe-dropdown__list': this.props.feStyle === 'dropdown',
        'fe-list--collapsed': this.props.feStyle === 'list' && this.props.isCollapsed
      }, this.props.className);
      var listGroupProps = Object.assign({}, this.props);
      delete listGroupProps.feStyle;
      delete listGroupProps.idAttribute;
      delete listGroupProps.isCollapsed;
      delete listGroupProps.icon;
      delete listGroupProps.iconRight;
      delete listGroupProps.iconMultiLevel;
      delete listGroupProps.iconExpand;
      delete listGroupProps.iconCollapse;
      delete listGroupProps.list;
      delete listGroupProps.activeId;
      delete listGroupProps.activeIds;
      delete listGroupProps.onItemClick;
      delete listGroupProps.onIconRighClick;
      delete listGroupProps.onItemHover;
      delete listGroupProps.activeParent;
      delete listGroupProps.textHighlight;
      delete listGroupProps.isSectioned;
      delete listGroupProps.isSelectBox;
      delete listGroupProps.activeItemIndex;
      delete listGroupProps.activeSubItemIndex;
      delete listGroupProps.expandedIndex;
      delete listGroupProps.isExpandAll;
      delete listGroupProps.isSublist;
      delete listGroupProps.withDropIcon;
      delete listGroupProps.customRenderLink;
      var setActive = this.props.activeParent || !this.props.isSublist;
      return _react.default.createElement("ul", _extends({}, listGroupProps, {
        className: className
      }), this.props.list.map(function (item, key) {
        var active = setActive && (_this.props.activeItemIndex && (0, _toInteger.default)(_this.props.activeItemIndex) === key || _this.isActiveItem(item));

        var activeSubItemIndex = active && !_this.props.isSublist ? _this.props.activeSubItemIndex : null;
        var expanded = _this.props.isExpandAll || _this.props.isSectioned || !_this.props.isSublist && _this.props.expandedIndex && (0, _toInteger.default)(_this.props.expandedIndex) === key;
        var role = (0, _ariaRole.getRole)(_this.props.role);
        var itemIndex = key;
        var iconRight = !_this.props.isSectioned && item.list && item.list.length ? _this.props.iconMultiLevel : _this.props.iconRight;
        return _react.default.createElement(_FeListItem.default, _extends({
          key: key,
          feStyle: _this.props.feStyle,
          icon: _this.props.icon,
          iconRight: iconRight,
          iconCollapse: _this.props.iconCollapse,
          iconExpand: _this.props.iconExpand,
          groupClickHandler: _this.props.onItemClick,
          groupIconRighClickHandler: _this.props.onIconRighClick,
          groupHoverHandler: _this.props.onItemHover,
          withDropIcon: _this.props.feStyle === 'list' && _this.props.withDropIcon
        }, item, {
          idAttribute: _this.props.idAttribute,
          activeId: _this.props.activeId,
          activeIds: _this.props.activeIds,
          textHighlight: _this.props.textHighlight,
          role: role,
          active: active,
          activeItemIndex: activeSubItemIndex,
          expanded: expanded,
          isSectioned: _this.props.isSectioned,
          itemIndex: "".concat(itemIndex),
          customRenderLink: _this.props.customRenderLink
        }));
      }));
    }
  }]);

  return FeListItemGroup;
}(_react.Component);

FeListItemGroup.defaultProps = {
  feStyle: 'list',
  idAttribute: null,
  list: [],
  activeId: null,
  activeIds: null,
  role: 'listbox',
  icon: null,
  iconRight: null,
  iconCollapse: 'fa fa-chevron-down',
  iconExpand: 'fa fa-chevron-up',
  activeItemIndex: null,
  activeSubItemIndex: null,
  expandedIndex: null,
  textHighlight: null,
  isSectioned: false,
  isSelectBox: false,
  isExpandAll: false,
  isSublist: false,
  withDropIcon: true,
  isCollapsed: false,
  onItemClick: null,
  onIconRighClick: null,
  onItemHover: null,
  customRenderLink: null
};
FeListItemGroup.propTypes = {
  /** Provide list group variants like 'list', 'dropdown'*/
  feStyle: _propTypes.default.oneOf(['list', 'dropdown']),

  /** Provide idAttribute for list item if id attributes is not passes and other attribute can be assumed as id and same for subitems*/
  idAttribute: _propTypes.default.string,

  /** Provide list group item list*/
  list: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,

  /** Provide active ids*/
  activeId: _propTypes.default.string,

  /** Provide active ids*/
  activeIds: _propTypes.default.array,

  /** Provide list group role for aria-attribute*/
  role: _propTypes.default.string,

  /** Provide icon class*/
  icon: _propTypes.default.string,

  /** Provide icon class*/
  iconRight: _propTypes.default.string,

  /** Provide icon class*/
  iconCollapse: _propTypes.default.string,

  /** Provide icon class*/
  iconExpand: _propTypes.default.string,

  /** Provide icon class*/
  iconMultiLevel: _propTypes.default.string,

  /** Provide item index to set active*/
  activeItemIndex: _propTypes.default.string,

  /** Provide subitem index to set active*/
  activeSubItemIndex: _propTypes.default.string,

  /** Provide item index for expanded state*/
  expandedIndex: _propTypes.default.string,

  /** Provide substring to highlight*/
  textHighlight: _propTypes.default.string,

  /** Set true/false to change list group sectioned state*/
  isSectioned: _propTypes.default.bool,

  /** Set true/false to change list group selectbox*/
  isSelectBox: _propTypes.default.bool,

  /** Set true/false to change expand state of all items*/
  isExpandAll: _propTypes.default.bool,

  /** Set true/false to change list type sublist*/
  isSublist: _propTypes.default.bool,

  /** Set true/false to add/remove dropdown icon*/
  withDropIcon: _propTypes.default.bool,

  /** Set true/false to change collapsed state of list group*/
  isCollapsed: _propTypes.default.bool,

  /** Provide right icon click handler for group items*/
  onIconRighClick: _propTypes.default.func,

  /** Provide item click handler for group items*/
  onItemClick: _propTypes.default.func,

  /** Provide item hover handler for group items*/
  onItemHover: _propTypes.default.func,

  /** A function that returns a react element to render the wrapping link.
   *  Will receive url, className, and children props
   */
  customRenderLink: _propTypes.default.func
};
FeListItemGroup.displayName = 'FeListItemGroup';
var _default = FeListItemGroup;
exports.default = _default;